import { createActionDuck } from "./action";
const RESET_LOCK_STATUS = `PANEL/RESET_LOCK_STATUS`;
export function resetPanelLockStatus() {
    return { type: RESET_LOCK_STATUS };
}
export function createLockStatusDuck(lockActionKeys, unlockActionKeys, saveActionKeys, computePanelId) {
    const actions = {
        resetPanelLockStatus,
    };
    function reducer(state = {}, action) {
        switch (action.type) {
            case lockActionKeys.FINISH:
                return Object.assign(Object.assign({}, state), { [action.id]: true });
            case unlockActionKeys.FINISH:
                return Object.assign(Object.assign({}, state), { [action.id]: false });
            case saveActionKeys.FINISH:
                return Object.assign(Object.assign({}, state), { [action.id]: false });
            case RESET_LOCK_STATUS:
                return {};
            default:
                return state;
        }
    }
    const isLocked = (state, config) => {
        const id = computePanelId(config);
        const item = state[id] || false;
        return item;
    };
    const selectors = { isLocked };
    const middleware = [];
    return { actions, selectors, middleware, reducer };
}
const createLockActions = (name, computePanelId, computeLockUrl, computeUnlockUrl, computePanelUpdateUrl = undefined) => {
    const lockDuck = createActionDuck(`${name}_LOCK`, computeLockUrl, computePanelId);
    const unlockDuck = createActionDuck(`${name}_UNLOCK`, computeUnlockUrl, computePanelId);
    const updateDuck = createActionDuck(`${name}_SAVE`, computePanelUpdateUrl, computePanelId);
    const lockStatusDuck = createLockStatusDuck(lockDuck.ActionKeys, unlockDuck.ActionKeys, updateDuck.ActionKeys, computePanelId);
    return { lockDuck, unlockDuck, updateDuck, lockStatusDuck };
};
export const getLockDucks = (name, computeUrl, computeId) => {
    const computeUpdateUrl = (config) => ({
        method: "POST",
        url: `${computeUrl(config)}`,
    });
    const computeLockUrl = (config) => ({
        method: "POST",
        url: `${computeUrl(config)}/lock`,
    });
    const computeUnlockUrl = (config) => ({
        method: "POST",
        url: `${computeUrl(config)}/unlock`,
    });
    return createLockActions(name, computeId, computeLockUrl, computeUnlockUrl, computeUpdateUrl);
};
//# sourceMappingURL=lock.js.map